// Reclamo del premio por calificar en Tiendanube —
// ADR-2026-10-12-premio-por-calificar-en-tiendanube.
//
// Sólo existe la vía del backend nuevo: este premio nació después de la migración y no
// tiene webhook de n8n al que volver. Con `VITE_USE_ATLAS_BACKEND=false` el cartel ni
// siquiera sale (lo corta `useHomeBanners`).

import { atlasBackendFetch } from './atlasBackend';
import { PREMIO_CALIFICAR_TIENDANUBE } from './calificacionTiendanube';

export type ReclamoCalificacionResult =
  /** Acreditado. `imagesCredited` es lo que dijo el servidor. */
  | { status: 'ok'; imagesCredited: number }
  /** Ya lo había cobrado: no se re-acredita, pero el cartel tiene que irse. */
  | { status: 'already_granted' }
  /** Nada se acreditó — se puede reintentar. */
  | { status: 'error'; message: string };

const ERROR_GENERICO = 'No pudimos acreditar tus imágenes. Probá de nuevo en unos segundos.';

export async function reclamarPremioCalificacion(): Promise<ReclamoCalificacionResult> {
  let res: Response;
  try {
    res = await atlasBackendFetch('/v1/feedback/calificacion-tiendanube', {});
  } catch {
    return { status: 'error', message: ERROR_GENERICO };
  }

  if (res.status === 409) return { status: 'already_granted' };
  // 403 (no le corresponde) o 500 (rollback): no se acreditó nada.
  if (!res.ok) return { status: 'error', message: ERROR_GENERICO };

  let credited = PREMIO_CALIFICAR_TIENDANUBE;
  try {
    const json = (await res.json()) as { imagenes_acreditadas?: number };
    if (typeof json?.imagenes_acreditadas === 'number') credited = json.imagenes_acreditadas;
  } catch {
    /* body raro pero 200: se acreditó igual, usamos el default */
  }
  return { status: 'ok', imagesCredited: credited };
}
